/**
 * Particle curve mode.
 */
export enum ParticleCurveMode {
  /* Single constant mode. */
  Constant,
  /* Random value between two constants mode. */
  TwoConstants,
  /* Single curve mode. */
  Curve,
  /* Random value between two curves mode. */
  TwoCurves
}
